
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lister]",
      function () {
        return require("private-next-pages/[lister].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lister]"])
      });
    }
  